module.exports = __webpack_public_path__ + "img/vinyl-plate.2e29b45e.png";